<template>
  <div class="mySubDepartment">
    <toptitle :title1="titlework" />

    <form action="/">
      <van-search v-model="valueSearch"
                  placeholder="请搜索"
                  @search="onSearch"
                  @input="inputSearch">
        <template #action>
          <div @click="onCancel">取消</div>
        </template>
      </van-search>
    </form>
    <div class="top-nav">
      <van-swipe-cell>
        <ul class="breakcrumb">
          <li>
            <router-link to="/"
                         class="link-a">首页</router-link>
          </li>
          <li>
            <router-link to="/myteam"
                         class="link-a">组织架构</router-link>
          </li>

          <li>
            <router-link :to="{ path: '/teamemployees',query:{companyTitle:companyTitle,EMPLID:emplid,DEPTID:deptId} }"
                         class="link-a">{{companyTitle}} </router-link>
          </li>
          <li>{{deptTitle}}</li>
        </ul>
      </van-swipe-cell>

    </div>

    <van-empty v-show="emptyShow"
               description="暂无人员数据" />
    <van-list @load="loadMore"
              :finished="loadFinished"
              finished-text="没有更多了">

      <section v-for="(item, index) in sonTeamEmployeesList"
               :key="index">
        <div class="divimg"
             @click="choose(item)">
          <img v-if="item.PHOTO != ''"
               :src="`data:image/png;base64,${item.PHOTO}`"
               alt="" />
          <div class="divnameone"
               v-else>{{ item.NAME | cutName }}</div>
        </div>

        <div class="divInfo"
             @click="choose(item)">
          <p class="divname">{{ item.NAME }}</p>
          <p>{{ item.POSN_DESCR }}</p>
        </div>
        <!-- <div class="teamSon"
             v-if="item.ROLE === 'Y'">
          <p @click="gotoSonTeam(item)">查看团队</p>
        </div> -->
      </section>
    </van-list>
    <loading-show :isLoadindShow="loading"></loading-show>
  </div>
</template>

<script>
import { getMyTeamsonDataApi } from '../../request/api'
import toptitle from '../../components/toptitle'
import LoadingShow from '../../components/loading'
export default {
  components: { toptitle, LoadingShow },
  data() {
    return {
      titlework: '我的团队',
      companyTitle: '',
      deptTitle: '',
      emplid: '',
      deptId: '',
      activeKey: 0,
      valueSearch: '',
      loading: false,
      loadFinished: false,
      emptyShow: false,
      currentPageNo: 1,
      maxPageNo: 0,
      sonTeamEmployeesList: [],
      // 搜索历史列表
      hislist: [],
      obj: {},
    }
  },
  created() {
    this.deptId = this.$route.query.DEPTID
    this.emplid = this.$route.query.fixEmplid
    this.deptTitle = this.$route.query.deptTitle
    this.companyTitle = this.$route.query.companyTitle

    // 定义数组接收本地存储的历史记录
    let history = localStorage.hislist
    if (history) {
      // 将数组转字符串
      this.hislist = JSON.parse(history)
    }
    this.getTeamEmployeesApi('')
  },

  methods: {
    onSearch() {},
    /**
     * 搜索部门
     * **/
    inputSearch() {
      this.currentPageNo = 1
      if (this.valueSearch.length > 0) {
        this.getTeamEmployeesApi(this.valueSearch)
      } else {
        this.getTeamEmployeesApi('')
      }
    },
    onCancel() {
      this.valueSearch = ''
      this.getTeamEmployeesApi('')
    },

    loadMore() {
      //加载下一页的数据
      this.currentPageNo++

      if (this.currentPageNo > this.maxPageNo) {
        //已经加载到了最后一页
        this.loadFinished = true
      } else {
        this.getTeamEmployeesApi('')
      }
    },
    /**
     * 获取团队成员点击
     * **/
    choose(val) {
      this.obj = val

      // //如果有的话就删除重复
      this.hislist.forEach((item) => {
        if (item.EMPLID == this.obj.EMPLID) {
          this.hislist.splice(this.hislist.indexOf(item), 1) //this.hislist.indexOf(item) 可以找到它的下标
        }
      })
      //向数组第一位添加
      this.hislist.unshift(this.obj)

      //如果数组长度大于四，就删除最后一项
      if (this.hislist.length > 4) {
        this.hislist.splice(5, 1)
      }

      this.hislist.forEach((item) => {
        item.PHOTO = item.PHOTO.replace(/<br>/g, '')
      })
      //本地存储历史记录数组
      localStorage.hislist = JSON.stringify(this.hislist)

      this.valueSearch = ''
      this.$store.commit('changeNum', this.obj.EMPLID)
      this.$router.push('/employees')
    },
    /**
     * 获取二级部门成员
     *  **/
    // gotoSonTeam(val) {
    //   this.currentPageNo = 1
    //   this.$router.push({
    //     path: '/sonteamemployees/' + val.EMPLID,
    //     query: {
    //       DEPTID: this.$route.query.DEPTID,
    //       fixEmplid: this.$route.query.fixEmplid,
    //       EMPLID: val.EMPLID,
    //       companyTitle: this.$route.query.companyTitle,
    //       deptTitle: this.$route.query.deptTitle,
    //     },
    //   })
    //   this.getTeamEmployeesApi('')
    // },

    /**
     *获取相关部门人员数据
     * **/

    getTeamEmployeesApi(value) {
      this.loading = true
      let params = {
        EMPLID: this.$route.query.EMPLID,
        PAGE: this.currentPageNo.toString(),
        RECORD: 100,
        POSITION_NBR: '',
        NAME: value,
      }

      getMyTeamsonDataApi(params).then((res) => {
        // console.log(res, 'res')
        if (res.CODE === 200) {
          let subBody = res.DATA.INFO
          //根据页面返回值决定是否要显示加载已完成的提示
          this.maxPageNo = parseInt(res.DATA.MAXPAGE)
          if (this.currentPageNo >= this.maxPageNo) {
            this.loadFinished = true
          } else {
            this.loadFinished = false
          }

          if (this.currentPageNo == 1) {
            //如果当前是第一页，清空相关数据
            this.sonTeamEmployeesList = []
          }
          this.sonTeamEmployeesList = this.sonTeamEmployeesList.concat(subBody)

          this.sonTeamEmployeesList.forEach((item) => {
            item.PHOTO = item.PHOTO.replace(/<br>/g, '')
          })

          if (this.sonTeamEmployeesList.length == 0) {
            this.emptyShow = true
            //this.$message('团队下暂无人员')
          } else {
            this.emptyShow = false
          }
          this.loading = false
        }
      })
    },
  },
  filters: {
    cutName(val) {
      return val.slice(0, 1)
    },
  },
}
</script>

<style  lang="less" scoped>
.top-nav {
  background: #fff;
}
.divnameone {
  margin-top: 0px;
}
section {
  height: 55px;
  background: white;
  font-size: 13px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  justify-content: flex-start;
  div {
    margin: 9px;
    p {
      color: #8f8f8f;
    }
    .divname {
      color: black;
      font-size: 15px;
    }
  }
  .divimg {
    width: 36px;
    height: 36px;
    background: #55a0f8;
    box-sizing: border-box;
    border-radius: 50%;
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      overflow: hidden;
    }
    text-align: center;
    line-height: 36px;
    font-size: 18px;

    color: white;
  }
  .divInfo {
    width: 55%;
  }
  .teamSon {
    P {
      color: #5076b7;
    }
  }
  .divright {
    flex: 1;
    line-height: 55px;
    margin: 0 10px 0 0;
    color: #55a0f8;
    text-align: right;
  }
}
/deep/.van-search {
  background: none;
}

.breakcrumb {
  display: flex;
  -webkit-box-flex: 1;
  overflow-x: scroll;
  white-space: nowrap;
  vertical-align: middle;
  height: 45px;
  margin: 0 0 0 5%;
  padding: 0;
  line-height: 45px;

  &::-webkit-scrollbar {
    height: 0;
    width: 0;
  }

  li {
    padding-right: 18px;
    font-size: 14px;
    .link-a {
      background: none;
    }
  }
  li:not(:last-child) {
    a {
      color: #5076b7;
    }
  }
  li:not(:last-child):after {
    display: inline-block;
    content: ' ';
    width: 5px;
    height: 5px;
    border-top: 1px solid #656565;
    border-right: 1px solid #656565;
    transform: rotate(45deg);
    -webkit-transform: rotate(45deg);
    position: relative;
    left: 10px;
    top: -2px;
    color: #5076b7;
  }
}
.breakcrumb::-webkit-scrollbar {
  display: none;
}
</style>

